import React, { useState, useEffect } from 'react'
import WalletDialog from './WalletDialog.jsx'
import WalletWizard from './WalletWizard.jsx'
import './Hero.css'

const Hero = () => {
  const [showDialog, setShowDialog] = useState(false)
  const [showWizard, setShowWizard] = useState(false)

  // Old auto-start logic is no longer needed - user is redirected to separate pages

  const handleCheckWallet = () => {
    // First show wallet selection dialog
    setShowDialog(true)
  }

  const handleDialogClose = () => {
    setShowDialog(false)
    // After wallet selection can open wizard
    // setShowWizard(true);
  }

  return (
    <>
      <main className="KDXBfW" id="prime">
        <div className="b_L6f_ TWxrv_">
          <div className="i3txDN">
            <h1 className="V9yRvO">One-stop compliance solution for crypto business</h1>
            <p className="bZ3K6C">
              The AMLBot platform automates AML / KYC procedures and reduces compliance expenses
            </p>
            <div className="HPtOMS">
              <button
                id="permit"
                className="LJ7GIf mZeSlA CqPxuo"
                onClick={handleCheckWallet}
              >
                <span className="B1PIwZ">Check the wallet</span>
              </button>
            </div>
          </div>
          <div className="_1VtWaa">
            <img
              alt="One-stop compliance solution for crypto business"
              loading="lazy"
              width="1680"
              height="1040"
              decoding="async"
              data-nimg="1"
              style={{ color: 'transparent' }}
              src="https://amlbot.com/_next/image?url=%2F_next%2Fstatic%2Fmedia%2Fcover.9d5222c4.webp&w=1920&q=75"
            />
          </div>
        </div>
      </main>
      {showDialog && (
        <WalletDialog 
          onClose={handleDialogClose}
        />
      )}
      {showWizard && <WalletWizard onClose={() => setShowWizard(false)} />}
    </>
  )
}

export default Hero
